import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

const CustomerInfo = ({ customerData, onCustomerInfoChange }) => {
  const handleChange = (field, value) => {
    if (onCustomerInfoChange) {
      onCustomerInfoChange(field, value);
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and limit to 11 digits
    const numbersOnly = value.replace(/\D/g, '');
    const limitedNumbers = numbersOnly.slice(0, 11);
    handleChange('phone', limitedNumbers);
  };

  return (
    <div className="customer-info">
      <h6 className="mb-3">Your Information</h6>
      <Form>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                value={customerData.name}
                onChange={(e) => handleChange('name', e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>
                Phone Number <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="tel"
                placeholder="01234567890"
                value={customerData.phone}
                onChange={handlePhoneChange}
                required
                pattern="[0-9]*"
                inputMode="numeric"
                maxLength={11}
              />
              <Form.Text className="text-muted">
                We'll use this to confirm your appointment
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="mb-3">
            <Form.Group>
              <Form.Label>Email Address (Optional)</Form.Label>
              <Form.Control
                type="email"
                placeholder="your.email@example.com"
                value={customerData.email}
                onChange={(e) => handleChange('email', e.target.value)}
              />
              <Form.Text className="text-muted">
                We'll send you a confirmation email
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="mb-3">
            <Form.Group>
              <Form.Label>Special Requests or Notes (Optional)</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Any special instructions or requests..."
                value={customerData.notes}
                onChange={(e) => handleChange('notes', e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CustomerInfo;
